import React from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaHome, FaInfoCircle, FaCogs, FaHandshake, FaFlag, FaEnvelopeOpenText, FaGlobe } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// --- Styled Components ---

const FooterContainer = styled.footer`
  background-color: #ffffff;
  padding: 30px 20px;
  border-top: 1px solid #eee;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const FooterGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnTitle = styled.h3`
  font-size: 1.5rem;
//   color: #1a2b49;
color:#439E6D;
  margin-bottom: 15px;
  font-weight:bold;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  color: #222; // The specific blue used in the image links
  font-size: 1.05rem;
  cursor:pointer;

  svg {
    margin-right: 12px;
    margin-top: 4px;
    color: #439E6D;
    font-size: 1rem;
  }
`;

const TextLink = styled.a`
  color: #222;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const CompanyText = styled.p`
  font-size: 1.05rem;
  line-height: 1.7;
  color: #222;
  margin: 0;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  color: #555;
  text-decoration: none;
  font-size: 1.05rem;

  svg {
    margin-right: 10px;
    color: #000;
  }
`;

// --- Component ---

const Footer = () => {

  const navigate = useNavigate();

  return (
    <FooterContainer>
      <FooterGrid>
        {/* Column 1: Address List */}
        <Column>
          <ColumnTitle>Address List</ColumnTitle>
          <InfoItem>
            <FaMapMarkerAlt />
            <span>
              23B School Road,<br />
              Rumuokwurusi, Port<br />
              Harcourt-Nigeria.
            </span>
          </InfoItem>
          <InfoItem>
            <FaPhoneAlt />
            <span>
              +234(0)8034579614<br />
              +234(0)904 974 3886
            </span>
          </InfoItem>
          <InfoItem>
            <FaEnvelope />
            <TextLink href="mailto:info@padecglobalservices.com">
              info@padecglobalservices.com
            </TextLink>
          </InfoItem>
          <CompanyText style={{  marginTop: '10px' }}>
            D-U-N-S NUMBER: 561379709
          </CompanyText>
        </Column>

        {/* Column 2: Social Networks */}
        <Column>
          <ColumnTitle>Social Networks</ColumnTitle>
          <SocialLink href="#">
            <FaFacebookF /> padecglobalservices
          </SocialLink>
        </Column>

        {/* Column 3: Links List */}
        <Column>
          <ColumnTitle>Links List</ColumnTitle>
          <InfoItem><FaHome /> <TextLink href="#">Home</TextLink></InfoItem>
          <InfoItem><FaInfoCircle /> <TextLink onClick={()=>navigate('/aboutus')}>About Us</TextLink></InfoItem>
          <InfoItem><FaCogs /> <TextLink onClick={()=>navigate('/services')}>Our Services</TextLink></InfoItem>
          <InfoItem><FaHandshake /> <TextLink onClick={()=>navigate('/news')}>News</TextLink></InfoItem>
          <InfoItem><FaFlag /> <TextLink onClick={()=>navigate('/nigeriancontent')}>Nigerian Content</TextLink></InfoItem>
          <InfoItem><FaEnvelopeOpenText /> <TextLink onClick={()=>navigate('/contactus')}>Contact Us</TextLink></InfoItem>
  
        </Column>

        {/* Column 4: Company Inc. */}
        <Column>
          <ColumnTitle>Company Inc.</ColumnTitle>
          <CompanyText>
            Padec Global Services Limited (PGSL) is a Company incorporated with a vision of pulling together, Engineers, Surveyors and GIS specialist to offer consultancy and contract services to Oil and gas Companies, various tiers of Government, Corporate bodies, Industries and Individual clients.
          </CompanyText>
        </Column>
      </FooterGrid>
    </FooterContainer>
  );
};

export default Footer;